import { apiClient } from './apiClient'
import type { Spot } from '../types/spot'

/**
 * Spots API (Plan 24 §5.3) — SpotController at /api/spots.
 */

export function getSpotsForTrack(trackId: string): Promise<Spot[]> {
  return apiClient.get<Spot[]>(`/api/spots?trackId=${encodeURIComponent(trackId)}`)
}

export function getSpotsByType(spotType: string): Promise<Spot[]> {
  return apiClient.get<Spot[]>(`/api/spots?type=${encodeURIComponent(spotType)}`)
}
